<div (blur)="close()" class="modal-content" [hidden]="!isOpen" style="border: none">
    <div class="modal-header">
        <span class="close" (click)="close()">&times;</span>
        <h4>{{title}}</h4>
    </div>
    <div class="modal-body">
        <p>{{description}}</p>
    </div>
</div>
